import { render } from "./EvaluationQuestionsCommentsDialog.vue?vue&type=template&id=e70bb920&scoped=true"
import script from "./EvaluationQuestionsCommentsDialog.vue?vue&type=script&lang=js"
export * from "./EvaluationQuestionsCommentsDialog.vue?vue&type=script&lang=js"

import "./EvaluationQuestionsCommentsDialog.vue?vue&type=style&index=0&id=e70bb920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70bb920"]])

export default __exports__